import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'
import { Page } from '../components/Page'
import Loading from '../shared/components/Loading'
import { Route } from '../routes/Route'
import { useAuthorizedData } from '../utils/Authorizable/authorize'

interface CompanySettingsProps {
  route?: Route
}

/**
 * Page frame for settings pages: breadcrumb and title come from the route. Pages add header buttons with
 * `PageActions`. Navigation between settings pages lives in the app sider (AppShell).
 */
const SettingsLayout: React.FC<CompanySettingsProps> = ({ route }) => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const authorizedRoute = useAuthorizedData(route)

  return (
    <Page breadcrumb description={t(`menuDescription:${pathname}`, '') || undefined}>
      <Suspense fallback={<Loading />}>
        <Outlet context={authorizedRoute} />
      </Suspense>
    </Page>
  )
}

export default SettingsLayout
